import { Entry } from '../Entry'

export function Entry20220914() {
  return (
    <Entry title="14/09/2022 - v3.2.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12749/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
